import { __commonJSMin as e } from "../../../../../../../_virtual/_rolldown/runtime.js";
//#region ../../node_modules/.pnpm/@intercom+intermoji@2.0.3/node_modules/@intercom/intermoji/lib/for_each_object.js
var t = /* @__PURE__ */ e(((e, t) => {
	t.exports = function(e, t) {
		for (var n in e) t(e[n], n);
	};
}));
//#endregion
export default t();
export { t as require_for_each_object };
